import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { SettingShipmentRules } from '../../models/SettingShipmentRules/SettingShipmentRules-model';
import { Observable } from 'rxjs/Observable';


import { Router } from "@angular/router";


import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class SettingShipmentRulesService {
  constructor(private http: Http, private readonly router: Router,
    private cookieService: CookieService) { }
  private serviceName = 'api/SettingShipmentRules';


  getSettingShipmentRules() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  addSettingShipmentRules(SettingShipmentRulesModel: SettingShipmentRules) {
    

    return this.http.post(`${this.serviceName}/CreateSettingShipmentRules`, SettingShipmentRulesModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  updateSettingShipmentRules(SettingShipmentRulesModel: SettingShipmentRules) {
    return this.http.post(`${this.serviceName}/UpdateSettingShipmentRules`, SettingShipmentRulesModel, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  deleteSettingShipmentRules(id: string) {
    return this.http.get(`${this.serviceName}/DeleteSettingShipmentRules?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
      //.map((response: Response) => response.json())
      //.catch(this.errorHandler);
  }

  getSettingShipmentRulesById(SettingShipmentRulesId: string) {
    return this.http.get(`${this.serviceName}/GetSettingShipmentRulesById?id=` + SettingShipmentRulesId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/SettingShipmentRules/SettingShipmentRules.service.ts